import { ActionCardContent } from './Content'
import { ActionCardIcon } from './Icon'
import { ActionCardInformation } from './Information'
import { ActionCardNotification } from './Notification'
import { ActionCardRoot } from './Root'

export const ActionCard = {
  Root: ActionCardRoot,
  Content: ActionCardContent,
  Information: ActionCardInformation,
  Icon: ActionCardIcon,
  Notification: ActionCardNotification,
}
